import type { AppModule } from '@/app/app-module.types';
import { CatalogIcon } from '@/shared/icons';
import { CATALOG_ROLES } from '@/shared/guards/roles';
import { catalogContainer } from './di/container';
import { CatalogRepositoryToken } from './di/tokens';
import { catalogRoutes } from './presentation/routes';

/**
 * Módulo de Catálogo (= CatalogModule no monolith): produtos, perks, roles,
 * features e módulos de permissão. Aparece no grupo "Gerenciamento" da
 * sidebar para `CATALOG_ROLES` (ADMINISTRATOR; SYSTEM_ADMINISTRATOR é
 * curinga).
 */
export const catalogModule: AppModule = {
  name: 'catalog',

  register(container) {
    container.register(
      CatalogRepositoryToken,
      () => catalogContainer.repository,
    );
  },

  routes: catalogRoutes,

  menu: [
    {
      label: 'Catálogo',
      to: '/management/catalog',
      icon: CatalogIcon,
      section: 'registry',
      order: 2,
      roles: CATALOG_ROLES,
    },
  ],
};
